import { useState } from 'react';
import { useNavigate } from 'react-router';
import FunnelNavigation from '@/components/ui/FunnelNavigation';
import { userStore } from '@/store/user/store';
import { useAuthRedirect } from '@/hooks/useAuthRedirect';
import FunnelContainer from '@/components/layouts/FunnelContainer';

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = userStore();
  const [redirectPath, setRedirectPath] = useState<string>('');

  useAuthRedirect(redirectPath);

  const back = () => {
    const prevPath = localStorage.getItem('prevPath');

    if (prevPath) {
      navigate(-1);
    } else if (user?.id) {
      if (user.registration_state === 'completed') {
        setRedirectPath('dashboard');
      } else {
        navigate('/user-demographics', { replace: true });
      }
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <FunnelContainer>
      <div className="flex flex-col text-left">
        <h1 className="text-h1 text-ashgray mt-32 tablet:mt-[80px]">404</h1>
        <p className="text-h1 text-ashgray-soft mt-[6px] tablet:mt-12 mb-12 tablet:mb-0">
          Page not found
        </p>
        <FunnelNavigation
          isPrevDisable
          nextButtonText="Go Back"
          preventNavigation={true}
          onNext={back}
          nextButtonClassName="tablet:!rounded-[16px] !w-full"
        />
      </div>
    </FunnelContainer>
  );
};

export default NotFound;
